<template>
  <div class="loading-bar-container">
    <loading-bar />
  </div>
</template>

<script>
import LearningPathSetupMixin from '@/mixins/learningPathSetup';
import LoadingBar from '@/components/singletons/loading-bar';

export default {
  components: {
    LoadingBar,
  },
  mixins: [LearningPathSetupMixin],
  created() {
    this.$store.dispatch('flashcardStates/fetchStates', ['bookmarks', 'flashcards', 'stats'])
      .then(() => {
        this.setupLearningPath();
        this.gotoLearningPath();
      });
  },
};
</script>
